import { fork } from 'redux-saga/effects';

import { routinePromiseWatcherSaga } from 'redux-saga-routines';

import {
  watchLoginSaga,
  watchFetchUserSaga,
  watchLogoutSaga,
  watchResetPasswordSaga,
  watchRegisterSaga
} from './authentication';
import {
  watchFetchCustomersSaga,
  watchFetchCustomerSaga,
  watchSaveCustomerSaga,
  watchRemoveCustomerSaga,
} from './customers';
import {
  watchFetchJobsSaga,
  watchFetchJobSaga,
  watchSaveJobSaga,
  watchSaveJobResourcesSaga,
  watchRemoveJobSaga,
} from './jobs';
import {
  watchFetchTasksSaga, watchFetchTaskSaga,
  watchUploadTasksSaga, watchSaveTaskAssignmentsSaga,
  watchEditTaskSaga, watchRemoveTasksSaga,
} from './tasks';
import { watchFetchTaskFileConfigsSaga } from './taskfileconfigs';
import {
  watchFetchEmployeesSaga,
  watchFetchEmployeeSaga,
  watchSaveEmployeeSaga,
  watchRemoveEmployeeSaga,
} from './employees';
import {
  watchFetchJobProfilesSaga,
  watchFetchJobProfileSaga,
  watchSaveJobProfileSaga,
  watchRemoveJobProfileSaga,
} from './jobprofiles';
import {
  watchFetchTaskProfilesSaga,
  watchFetchTaskProfileSaga,
  watchSaveTaskProfileSaga,
  watchRemoveTaskProfileSaga
} from './taskprofiles';
import { watchFetchRolesSaga, watchSaveRoleSaga, watchRemoveRoleSaga } from './roles';
import { watchFetchStaticSaga } from './static';
import { watchFetchItemTypesSaga } from './itemtypes';
import { watchFetchLabelFormatsSaga } from './labelformats';
import { watchFetchRecentActivitySaga } from './activity';
import { watchFetchExceptionsSaga } from './exceptions';
import {
  watchConfirmPasswordResetLinkSaga, watchEmailVerificationSaga,
  watchConfirmPasswordResetSaga,
} from './firebase';
import { watchFetchPrintersSaga, watchSavePrinterSaga, watchRemovePrinterSaga } from './printers';
import {
  watchFetchTenants,
  watchAddTenantSaga,
  watchUpgradeTenant,
  watchGetTaskCount,
  watchFetchInvoices,
  watchGetPaymentSource,
  watchUpdatePaymentSource,
  watchCancelAccount,
} from './tenants';

export default function* rootSaga() {
  yield fork(watchLoginSaga);
  yield fork(watchFetchUserSaga);
  yield fork(watchLogoutSaga);

  yield fork(watchFetchTenants);
  yield fork(watchAddTenantSaga);

  yield fork(watchResetPasswordSaga);
  yield fork(watchRegisterSaga);

  yield fork(watchFetchCustomersSaga);
  yield fork(watchFetchCustomerSaga);
  yield fork(watchSaveCustomerSaga);
  yield fork(watchRemoveCustomerSaga);

  yield fork(watchFetchJobsSaga);
  yield fork(watchFetchJobSaga);
  yield fork(watchSaveJobSaga);
  yield fork(watchSaveJobResourcesSaga);
  yield fork(watchRemoveJobSaga);

  yield fork(watchFetchExceptionsSaga);

  yield fork(watchFetchEmployeesSaga);
  yield fork(watchFetchEmployeeSaga);
  yield fork(watchSaveEmployeeSaga);
  yield fork(watchRemoveEmployeeSaga);

  yield fork(watchFetchJobProfilesSaga);
  yield fork(watchFetchJobProfileSaga);
  yield fork(watchSaveJobProfileSaga);
  // yield fork(watchSaveJobProfileStageSaga);
  yield fork(watchRemoveJobProfileSaga);
  // yield fork(watchRemoveJobProfileStageSaga);

  yield fork(watchFetchTaskProfilesSaga);
  yield fork(watchFetchTaskProfileSaga);
  yield fork(watchSaveTaskProfileSaga);
  yield fork(watchRemoveTaskProfileSaga);

  yield fork(watchFetchTasksSaga);
  yield fork(watchFetchTaskSaga);
  yield fork(watchRemoveTasksSaga);

  yield fork(watchFetchTaskFileConfigsSaga);

  yield fork(watchFetchRolesSaga);
  yield fork(watchSaveRoleSaga);
  yield fork(watchRemoveRoleSaga);

  yield fork(watchFetchStaticSaga);
  yield fork(watchFetchItemTypesSaga);

  yield fork(watchUploadTasksSaga);
  yield fork(watchSaveTaskAssignmentsSaga);

  // yield fork(watchRegisterUserSaga);
  // yield fork(watchRegistrationSuccessSaga);
  // yield fork(watchChangeUserPassword);
  // yield fork(watchFetchUserSaga);

  yield fork(watchFetchLabelFormatsSaga);

  yield fork(watchConfirmPasswordResetLinkSaga);
  yield fork(watchConfirmPasswordResetSaga);
  yield fork(watchEmailVerificationSaga);

  yield fork(watchFetchRecentActivitySaga);
  yield fork(watchEditTaskSaga);

  yield fork(watchFetchPrintersSaga);
  yield fork(watchSavePrinterSaga);
  yield fork(watchRemovePrinterSaga);

  yield fork(watchUpgradeTenant);
  yield fork(watchGetTaskCount);
  yield fork(watchGetPaymentSource);
  yield fork(watchUpdatePaymentSource);
  yield fork(watchFetchInvoices);
  yield fork(watchCancelAccount);

  // yield fork(routinesWatcherSaga); //TODO auth0 fix

  yield fork(routinePromiseWatcherSaga);
};



// WEBPACK FOOTER //
// ./src/sagas/index.js